import {BrowserRouter as Router} from 'react-router-dom';
import React from 'react';
import Routes from './Utility/Routes';
// import LoadingContext from './Components/Main/context/LoadingContext';
const App = ()=>{
  // const [loading,setLoading] = useState(true);
  return (
    <div className="App">
      {/* <LoadingContext.Provider value ={{ isLoading: loading,setLoading }}> */}
        <Router>
          <Routes></Routes>
        </Router>
      {/* </LoadingContext.Provider> */}
    </div>
  );
}

export default App;
